import { ChangeDetectionStrategy, Component } from '@angular/core';
import { jkBaseForm, TitlebarComponent } from 'jk-service';
import { HindsightQueryComponent } from '../components/hindsight-query/hindsight-query.component';

@Component({
  selector: 'app-utyjb55', standalone: true,
  imports: [TitlebarComponent, HindsightQueryComponent],
  templateUrl: './utyjb55.component.html', styleUrl: './utyjb55.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class Utyjb55Component extends jkBaseForm {
  override _programId = 'utyjb55';
  override async ngAfterViewInit() {
    await super.ngAfterViewInit();
    this.checkAllInit(this);
  }
}
